export default {"src":"/_next/static/media/ticket.62a5908e.svg","height":64,"width":60};